import React from 'react';
import Header from 'components/Header';
import ProceduresList from './components/List';
import '../../../Evaluations/evaluations.less';
import AppContext from 'components/appContext';
import UIComponent from 'components/UiComponent';
import config from 'root/../config';
import {i18nInit} from 'root/internationalization/config';

const sceneCode = "PROCEDURE_EVALUATIONS_LIST";

export default class ProcedureEvaluationList extends React.Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);
        this.state = {
            filter: null,
        }
    }

    componentDidMount(){
        this.context.setCurrentScene(sceneCode);
    }

    _onFilterSubmit(meta,data) {
        this.setState({
            filter: meta,
        })
    }

    _filterOptions() {
        return {
            SUPERVISOR: {
                entityList: "TRAINEE_EVAL_FILTER,ESCH_EVALS_PROC_PORT,ESCH_PROCEDURE",
                defaultFields: "",
                persistenceKey: "PROC_SUPERVISOR_EVAL_FILTER_",
                filterFieldsConditions: "",
            },
            TRAINEE: {
                entityList: "ESCH_EVAL_ACT,ESCH_SUPERVISOR_ACT,ESCH_EVALS_PROC_PORT,ESCH_PROCEDURE",
                defaultFields: "",
                persistenceKey: "PROC_TRAINEE_EVAL_FILTER_",
                filterFieldsConditions: `{
                    "ActivityEval.*" : "ActivityEval.ACTIVITY_ID is not null  AND EschEvalDetail.TRAINEE_ID = ${this.context.userDetails.USER_ID}", 
                    "EschProcDetail.*" : "EschProcDetail.TRAINEE_ID = ${this.context.userDetails.USER_ID}"
                }`,
            },
            STUDENT: {
                entityList: "ESCH_EVAL_ACT,ESCH_SUPERVISOR_ACT",
                defaultFields: "EschEvalDetail.EVAL_STATUS_NAME",
                persistenceKey: "PROC_STUDENT_EVAL_FILTER_",
                filterFieldsConditions: "",
            },
            ADMIN: {
                entityList: "TRAINEE_EVAL_FILTER,ESCH_EVALS",
                defaultFields: "EschEvalDetail.EVAL_STATUS_NAME",
                persistenceKey: "PROC_EVAL_FILTER_",
                filterFieldsConditions: "",
            }
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="evaluation-scene full-height--with-policy flex-column row">
                    <Header {...this.props} elevation={false} />
                    <UIComponent
                        name="filter"
                        component="filter"
                        includeSearchField
                        autoSubmit
                        grouping
                        allowPinField={false}
                        placeholder={<div className="text-mock bg-primary-placeholder shine"></div>}
                        submitCallback={this._onFilterSubmit.bind(this)}
                        filterTitle={i18nInit.t('lbl.FILTER_PROCEDURES','Filter procedures')}
                        apiEntryPoint={config.apiAppUrl}
                        autoPersistence

                        filterID="evaluation-filter"
                        entityFilterCode={this._filterOptions()[this.context.userDetails.CURRENT_ROLE].entityList}
                        defaultFields={this._filterOptions()[this.context.userDetails.CURRENT_ROLE].defaultFields}
                        persistenceKey={`${this._filterOptions()[this.context.userDetails.CURRENT_ROLE].persistenceKey}${Object.keys(this.context.userDetails).length ? this.context.userDetails.USER_ID : null}`}
                        filterFieldsConditions={this._filterOptions()[this.context.userDetails.CURRENT_ROLE].filterFieldsConditions}
                        userId={Object.keys(this.context.userDetails).length ? this.context.userDetails.USER_ID : null}
                        tabIndexContainer = {".popover-content"}
                />
    
                    <div className="evaluations-container flex-grow-1 justify-content-center align-items-center">
                        <ProceduresList filter={this.state.filter}/>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}